export const CLEAR_HRA_EDIT_FORM_ERROR = 'CLEAR_HRA_EDIT_FORM_ERROR';
export const CLEAR_PATIENT_EDIT_FORM_ERROR = 'CLEAR_PATIENT_EDIT_FORM_ERROR';
export const GET_PATIENTS_FAILURE = 'GET_PATIENTS_FAILURE';
export const GET_PATIENTS_REQUEST = 'GET_PATIENTS_REQUEST';
export const GET_PATIENTS_SUCCESS = 'GET_PATIENTS_SUCCESS';
export const UPDATE_PATIENT_FAILURE = 'UPDATE_PATIENT_FAILURE';
export const UPDATE_PATIENT_HRA_FAILURE = 'UPDATE_PATIENTS_HRA_FAILURE';
export const UPDATE_PATIENTS_DATA = 'UPDATE_PATIENTS_DATA';
export const UPDATE_PATIENTS_SCOPEFILTER = 'UPDATE_PATIENTS_SCOPEFILTER';
